export enum GLOBAL_BENCHMARK_MODULES {
  GLOBAL_BENCHMARK_WELLS_SELECTION = 'GLOBAL_BENCHMARK_WELLS_SELECTION',
  GLOBAL_BENCHMARK_TIME_BREAKDOWN = 'GLOBAL_BENCHMARK_TIME_BREAKDOWN',
  GLOBAL_BENCHMARK_BOP_OPERATIONS = 'GLOBAL_BENCHMARK_BOP_OPERATIONS',
  GLOBAL_BENCHMARK_DRILLING = 'GLOBAL_BENCHMARK_DRILLING',
  GLOBAL_BENCHMARK_TRIPPING = 'GLOBAL_BENCHMARK_TRIPPING',
  GLOBAL_BENCHMARK_CASING_RUNNING = 'GLOBAL_BENCHMARK_CASING_RUNNING',
}

export const globalBenchmarkModules = Object.values(GLOBAL_BENCHMARK_MODULES);
